// src/Register.js
import React, { useState, useEffect } from 'react';
import { Button, Form, Col, Row, Card, Container, Dropdown, DropdownButton, ProgressBar, Icon } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from "react-icons/io5";
import { BASE_URL } from '../config';

const Register = () => {
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    password: '',
    cnic: '',
    contactNo: '',
    dob: '',
    city: '',
    country: '',
    currentAddress: '',
    permanentAddress: '',
    licenseNo: '',
    medicalInstitute: '',
    experience: '',
    currentWorking: 'Yes',
    doctorDutyTime: '',
    charges: '',
    authority: '',
    institutecountry: '',
    terms: false,
    specialization: '',
    image: null,
    resume: null,
    medicalDegree: null,
    gender: '',
    institutename: '',
    SpecialtyId: '',
    consultationFee: '',
    feeType: 'PKR',
    network: 'zong',
  });

  const [specialists, setSpecialists] = useState([]);
  const [filteredSpecialists, setFilteredSpecialists] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const navigate = useNavigate()

  // Fetching specialists on component mount
  useEffect(() => {
    const fetchSpecialists = async () => {
      try {
        const response = await axios.get(`${BASE_URL}Specialist_List`, {
          headers: {
            accept: 'text/plain'
          }
        });
        setSpecialists(response.data.getSpecialistDetail);
        setFilteredSpecialists(response.data.getSpecialistDetail);
      } catch (error) {
        console.error('Error fetching specialists:', error);
      }
    };

    fetchSpecialists();
  }, []);

  // Handle specialty change and update formData
  const handleSpecialtyChange = (specialty) => {
    setFormData(prevData => ({
      ...prevData,
      specialization: specialty.specialization_Name,
      SpecialtyId: specialty.id // Use the correct ID from the selected specialty
    }));
  };

  // Filter specialists based on search term
  useEffect(() => {
    if (searchTerm) {
      const filtered = specialists.filter(specialist =>
        specialist.specialization_Name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSpecialists(filtered);
    } else {
      setFilteredSpecialists(specialists);
    }
  }, [searchTerm, specialists]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const validateStep = () => {
    let tempErrors = {};

    // Step 1: Email Validation
    if (step === 1) {
      if (!formData.email) {
        tempErrors.email = 'Email is required';
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        tempErrors.email = 'Email is not valid';
      }
    }
    // Step 2: Personal Info Validation
    if (step === 2) {
      if (!formData.password) {
        tempErrors.password = 'Password is required';
      } else if (formData.password.length < 6) {
        tempErrors.password = 'Password must be at least 6 characters';
      }
      if (!formData.fullName) {
        tempErrors.fullName = 'Name is required';
      }

      if (!formData.dob) {
        tempErrors.dob = 'Date of Birth is required';
      } else {
        const dob = new Date(formData.dob);
        const today = new Date();
        const age = today.getFullYear() - dob.getFullYear();
        const month = today.getMonth() - dob.getMonth();

        // Check if the user is under 20
        if (age < 20 || (age === 20 && month < 0)) {
          tempErrors.dob = 'You must be at least 20 years old';
        }
      }
      if (!formData.gender) {
        tempErrors.gender = 'Gender is required';
      }
      if (!formData.cnic) {
        tempErrors.cnic = 'CNIC is required';
      }
      if (!formData.contactNo) {
        tempErrors.contactNo = 'Mobile Number is required';
      }
      if (!formData.currentAddress) {
        tempErrors.currentAddress = 'Address is required';
      }
      if (!formData.city) {
        tempErrors.city = 'City is required';
      }
      if (!formData.country) {
        tempErrors.country = 'Country is required';
      }
    }
    // Step 3: Education Info Validation
    if (step === 3) {/*  */
      // if (!formData.licenseNo) {
      //   tempErrors.licenseNo = 'License Number is required';
      // }
      if (!formData.institutecountry) {
        tempErrors.institutecountry = 'Institute Country is required';
      }
      if (!formData.institutename) {
        tempErrors.institutename = 'Institute Name is required';
      }
      // if (!formData.medicalDegree) {
      //   tempErrors.medicalDegree = 'Medical Degree is required';
      // }
      if (!formData.specialization) {
        tempErrors.specialization = 'Specialization is required';
      }
    }

    // Step 4: Professional Info Validation
    if (step === 4) {
      if (!formData.experience) {
        tempErrors.experience = 'Experience is required';
      }
      if (!formData.dutyStartTime) {
        tempErrors.dutyStartTime = 'Start time is required';
      }
      if (!formData.dutyEndTime) {
        tempErrors.dutyEndTime = 'End time is required';
      }
      if (!formData.consultationFee) {
        tempErrors.consultationFee = 'Consultation Fee is required';
      }
      if (!formData.currentWorking) {
        tempErrors.currentWorking = 'Current Working status is required';
      }
      if (!formData.resume) {
        tempErrors.resume = 'Resume is required';
      }
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "consultationFee" || name === "feeType" || name === "network") {
      setFormData(prevState => {
        const updatedFormData = { ...prevState, [name]: value };

        // Combine numeric value and fee type into one field (consultationFee)
        // const fee = updatedFormData.consultationFee;
        // const feeType = updatedFormData.feeType;

        // if (fee && feeType) {
        //   updatedFormData.consultationFee = `${fee}`;
        // }

        return updatedFormData;
      });
    } else {
      // Handle other fields (checkboxes or text fields)
      setFormData(prevData => ({
        ...prevData,
        [name]: type === 'checkbox' ? checked : value
      }));
    }

    setFormData(prevData => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value
    }));

    setFormData(prevData => {
      let updated = {
        ...prevData,
        [name]: type === 'checkbox' ? checked : value,
      };

      // Auto-build doctorDutyTime if both times are present
      const start = name === "dutyStartTime" ? value : prevData.dutyStartTime;
      const end = name === "dutyEndTime" ? value : prevData.dutyEndTime;

      if (start && end) {
        const startTime = new Date(`1970-01-01T${start}`);
        const endTime = new Date(`1970-01-01T${end}`);

        if (endTime <= startTime) {
          // Set error
          setErrors(prev => ({
            ...prev,
            dutyEndTime: 'End time must be after start time',
          }));
        } else {
          // Clear error and update doctorDutyTime
          setErrors(prev => ({
            ...prev,
            dutyEndTime: null,
          }));
          updated.doctorDutyTime = `${start} - ${end}`;
        }
      }

      return updated;
    });

    if (name === "fullName") {
      setFormData(prevData => ({
        ...prevData,
        // [name]: value && !value.startsWith("Dr. ") ? `Dr. ${value}` : value
        [name]: value
      }));
    }
    if (name === 'gender') {
      setFormData(prevData => ({
        ...prevData,
        gender: value
      }));
    }
  };
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setFormData(prevData => ({
        ...prevData,
        [name]: files[0]
      }));
    }
  };
  const handleNext = async () => {
    if (validateStep()) {
      if (step === 1) {
        // Step 1: Validate Email (check if the email is valid and not already in use)
        setIsLoading(true); // Show loading indicator while the request is being processed
        try {


          // Make the API call to check if the email is valid and not in use
          const response = await fetch(`${BASE_URL}UserCheck`, {
            method: 'POST',
            headers: {
              'accept': 'text/plain',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: formData.email }), // Send the email to the API for validation
          });

          const data = await response.json(); // Parse the response

          // Check if the email is valid based on the response code
          if (data.responseCode === '0001') {
            // If the email is valid (responseCode '0001'), move to the next step
            setStep(step + 1);
          } else {
            // Show an error if the email is invalid or already in use
            Swal.fire({
              icon: 'error',
              title: 'Email is already in use or invalid',
              text: 'Please provide a valid email address.',
              confirmButtonText: 'OK',
            });
          }
        } catch (error) {
          // If there is an error in the API call, show an error message
          Swal.fire({
            icon: 'error',
            title: 'An error occurred',
            text: 'There was an error checking your email. Please try again later.',
            confirmButtonText: 'OK',
          });
        } finally {
          setIsLoading(false); // Hide the loading indicator after the API request finishes
        }
      } else {
        // For other steps (Step 2, Step 3, etc.), simply proceed to the next step
        setStep(step + 1);
      }
    }
  };
  const handlePrev = () => {
    setStep(step - 1);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Perform validation before submission
    if (validateStep()) {
      setIsSubmitting(true);
      // Prepare form data for submission
      const formDataObj = new FormData();
      formDataObj.append('Email', formData.email);
      formDataObj.append('Password', formData.password);
      formDataObj.append('MobileNumber', formData.contactNo);
      formDataObj.append('CNIC', formData.cnic);
      formDataObj.append('Name', formData.fullName);
      formDataObj.append('DoctorDutyTime', formData.doctorDutyTime);
      formDataObj.append('Gender', formData.gender);
      formDataObj.append('DateOfBirth', formData.dob);
      formDataObj.append('Address', formData.currentAddress);
      formDataObj.append('City', formData.city);
      formDataObj.append('SpecialtyId', formData.SpecialtyId);
      formDataObj.append('Country', formData.country);
      formDataObj.append('Specialization', formData.specialization || 'no');
      formDataObj.append('Experience', formData.experience + ' Years');
      formDataObj.append('Image', formData.image);
      formDataObj.append('Resume', formData.resume);
      formDataObj.append('CurrentWorking', formData.currentWorking);
      formDataObj.append('ConsultationFee', formData.consultationFee);
      formDataObj.append('FeeType', formData.feeType);
      formDataObj.append('network', formData.network);
      formDataObj.append('MedicalDegree', formData.medicalDegree);
      formDataObj.append('Authority', formData.authority);
      formDataObj.append('LicenseNo', formData.licenseNo);
      formDataObj.append('InstituteCountry', formData.institutecountry);
      formDataObj.append('InstituteName', formData.institutename);
      try {
        // Register Doctor Api
        const response = await fetch(`${BASE_URL}Specialist_RegisterDoctor`, {
          method: 'POST',
          body: formDataObj,
        });
        const data = await response.json();
        // Handle the response from the API
        if (!response.ok) {
          throw new Error(data.Message || data.message || 'Please contact with IT / Admin');
        }
        console.log('Registration successful:', data);
        //  success message
        Swal.fire({
          title: 'Success!',
          text: 'Registration successful!',
          icon: 'success',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          navigate('/');
        });

        // Reset form data after successful submission
        setFormData({
          fullName: '',
          email: '',
          password: '',
          cnic: '',
          contactNo: '',
          dob: '',
          city: '',
          country: '',
          currentAddress: '',
          permanentAddress: '',
          licenseNo: '',
          medicalInstitute: '',
          experience: '',
          currentWorking: '',
          consultationFee: '',
          feeType: '',
          network: '',
          doctorDutyTime: '',
          charges: '',
          terms: false,
          specialization: '',
          image: null,
          authority: '',
          institutecountry: '',
          resume: null,
          medicalDegree: null,
          gender: '',
          institutename: '',
          SpecialtyId: '',
        });

        setStep(1); // Reset to the first step if needed

      } catch (error) {
        console.error('Registration failed:', error);

        // Show  error message
        Swal.fire({
          title: 'Error!',
          text: error.message || 'An unexpected error occurred.',
          icon: 'error',
          confirmButtonText: 'OK',
        });

      } finally {
        setIsSubmitting(false);
      }
    }
  };
  const progress = (step / 5) * 100;
  const totalSteps = 5;
  return (
    <Container className="justify-content-center align-items-center mt-5">
      <Card className="shadow-md rounded">
        <Card.Header>
          <Row className="m-1">
            <Col md={12} className="d-flex justify-content-center position-relative">
              <div class="position-absolute top-50 start-0 translate-middle-y">
                <IoArrowBack color='#50c4cc' size={30} style={{ cursor: "pointer" }} onClick={() => navigate('/')} />
              </div>
              <img src="/logob.png" style={{ width: '150px', cursor: "pointer" }} alt="logo" onClick={() => navigate("/")} />
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Row className="m-1">
            <Col md={12} className="d-flex justify-content-center align-items-center mb-3">
              <h1 className="text-center">Doctor Registration Form</h1>
            </Col>
          </Row>
          <ProgressBar now={progress} label={`Step ${step} of ${totalSteps}`} style={{ height: '14px' }} />
          <Form onSubmit={handleSubmit}>
            {/* Step 1: Email */}
            {step === 1 && (
              <div className="step mt-3">
                <Form.Group controlId="formEmail">
                  <Form.Label className='mb-0'>Email</Form.Label>
                  <Form.Control

                    type="email"
                    className="form-control"

                    placeholder="Enter email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={errors.email}

                    required
                  />
                  <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                </Form.Group>
                <Row className="mt-4">
                  <Col className="d-flex justify-content-end mt-2">
                    <Button
                      className="w-100 btn_primary"
                      variant="primary"
                      onClick={handleNext}
                      size="lg"
                      disabled={isLoading || isSubmitting}
                    >
                      {isLoading ? 'Checking...' : 'Next'}
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            {/* Step 2: Personal Info */}
            {step === 2 && (
              <div className="step mt-3">
                <h3 className="text-center m-4">Personal Info</h3>
                <Row>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formName">
                      <Form.Label className='mb-0'>Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter name"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        isInvalid={errors.fullName}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formPassword">
                      <Form.Label className='mb-0'>Password</Form.Label>
                      <Form.Control
                        name='password'
                        type='password'
                        placeholder="Enter password"
                        value={formData.password}
                        onChange={handleChange}
                        isInvalid={errors.password}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                </Row>
                <Row>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formDateOfBirth">
                      <Form.Label className='mb-0'>Date of Birth</Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={formData.dob}
                        onChange={handleChange}
                        isInvalid={errors.dob}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formCnic">
                      <Form.Label className='mb-0'>CNIC</Form.Label>
                      <Form.Control
                        maxLength="13"
                        pattern="\d{13}"
                        value={formData.cnic}
                        type="text"
                        placeholder="Enter CNIC"
                        name="cnic"
                        onChange={handleChange}
                        isInvalid={errors.cnic}
                        inputMode="numeric"
                        onInput={(e) => {
                          // Allow only numbers by removing any non-numeric characters
                          e.target.value = e.target.value.replace(/\D/g, '');
                        }}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.cnic}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                </Row>
                <Row>
                  <Col md={6} className='mb-3'>
                    <div className='d-flex' style={{ gap: "10px" }}>
                      <Form.Group controlId="formMobileNumber" className='w-50'>
                        <Form.Label className='mb-0'>Select Network</Form.Label>
                        <Form.Control
                          as="select"
                          name="network"
                          className='mt-1 py-2'
                          value={formData.network || 'PKR'} // Default to PKR if not set
                          onChange={handleChange}
                          isInvalid={errors.network}
                          required
                        >
                          <option value="zong">Zong</option>
                          <option value="jazz">Jazz</option>
                          <option value="ufone">Ufone</option>
                          <option value="telenor">Telenor</option>
                        </Form.Control>
                      </Form.Group>
                      <Form.Group controlId="formMobileNumber" className='w-50'>
                        <Form.Label className='mb-0'>Mobile Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Mobile Number"
                          name="contactNo"
                          value={formData.contactNo}
                          onChange={handleChange}
                          isInvalid={errors.contactNo}
                          maxLength="12"
                          minLength="11" // Ensures at least 11 characters
                          inputMode="numeric"
                          pattern="\d{11,12}" // Only allows 12 or 12 digits.
                          onInput={(e) => {
                            // Allow only numbers by removing any non-numeric characters
                            e.target.value = e.target.value.replace(/\D/g, '');
                          }}
                          required
                        />
                        <Form.Control.Feedback type="invalid">{errors.contactNo}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formCity">
                      <Form.Label className='mb-0'>City</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter City"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        isInvalid={errors.city}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.city}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>

                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formGender">
                      <Form.Label className='mb-0'>Gender</Form.Label>
                      <Form.Control
                        as="select"
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        isInvalid={errors.gender}
                        required
                      >
                        <Form.Control.Feedback type="invalid">{errors.gender}</Form.Control.Feedback>
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="Female">Female</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  {/* <Col md={6} className='mb-3'>
                    <Form.Group controlId="formCountry">
                      <Form.Label className='mb-0'>Country</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Country"
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        isInvalid={errors.country}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.country}</Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formCountry">
                      <Form.Label className='mb-0'>Country</Form.Label>
                      <Form.Control
                        as="select" // This changes the control to a dropdown
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        isInvalid={errors.country}
                        required
                      >
                        <option value="">Select Country</option>
                        <option value="Afghanistan">Afghanistan</option>
                        <option value="Australia">Australia</option>
                        <option value="Belgium">Belgium</option>
                        <option value="Brazil">Brazil</option>
                        <option value="Canada">Canada</option>
                        <option value="China">China</option>
                        <option value="France">France</option>
                        <option value="Germany">Germany</option>
                        <option value="India">India</option>
                        <option value="Italy">Italy</option>
                        <option value="Japan">Japan</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Netherlands">Netherlands</option>
                        <option value="Pakistan">Pakistan</option>
                        <option value="Singapore">Singapore</option>
                        <option value="South Korea">South Korea</option>
                        <option value="Sweden">Sweden</option>
                        <option value="Switzerland">Switzerland</option>
                        <option value="Turkey">Turkey</option>
                        <option value="UK">UK</option>
                        <option value="USA">USA</option>

                      </Form.Control>
                      <Form.Control.Feedback type="invalid">{errors.country}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                </Row>
                <Row>
                  <Col md={12} className='mb-3'>
                    <Form.Group controlId="formImage">
                      <Form.Label className='mb-0'>Upload Image</Form.Label>
                      <Form.Control
                        type="file"
                        name="image"
                        onChange={handleFileChange}
                        isInvalid={errors.image}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.image}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Form.Group controlId="formAddress">
                      <Form.Label className='mb-0'>Address</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Address"
                        name="currentAddress"
                        value={formData.currentAddress}
                        onChange={handleChange}
                        isInvalid={errors.currentAddress}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.currentAddress}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md={6} className='mb-3'>
                    <Button className="w-100" variant="secondary" onClick={handlePrev} size="lg">
                      Previous
                    </Button>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Button className="w-100 btn_primary" variant="primary" onClick={handleNext} size="lg" block>
                      Next
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            {/* Step 3: Education Info */}
            {step === 3 && (
              <div className="step mt-3">
                <h3 className="text-center m-4">Education Info</h3>
                <Row>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formLicenseNo">
                      <Form.Label className='mb-0'>License No</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter License No"
                        name="licenseNo"
                        value={formData.licenseNo}
                        onChange={handleChange}
                      // isInvalid={errors.licenseNo}
                      // required
                      />
                      {/* <Form.Control.Feedback type="invalid">{errors.licenseNo}</Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formMedicalDegree">
                      <Form.Label className='mb-0'>Medical Degree</Form.Label>
                      <Form.Control
                        type="file"
                        name="medicalDegree"
                        onChange={handleFileChange}
                        isInvalid={errors.medicalDegree}
                      // required
                      />
                      {/* <Form.Control.Feedback type="invalid">{errors.medicalDegree}</Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>


                </Row>
                <Row>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formInstituteName">
                      <Form.Label className='mb-0'>Institute Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Institute Name"
                        name="institutename"
                        value={formData.institutename}
                        onChange={handleChange}
                        isInvalid={errors.institutename}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.instituteName}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formAllQualifications">
                      <Form.Label className='mb-0'>All Qualifications</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Qualifications"
                        name="allQualifications"
                        value={formData.allQualifications}
                        onChange={handleChange}
                        isInvalid={errors.allQualifications}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.allQualifications}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formInstituteCountry">
                      <Form.Label className='mb-0'>Institute Country</Form.Label>
                      <Form.Control
                        as="select" // Changed from type="text" to as="select" for dropdown
                        name="institutecountry"
                        value={formData.institutecountry}
                        onChange={handleChange}
                        isInvalid={errors.institutecountry}
                        required
                        className='mt-1'
                      >
                        <option value="">Select Institute Country</option>
                        <option value="Afghanistan">Afghanistan</option>
                        <option value="Australia">Australia</option>
                        <option value="Belgium">Belgium</option>
                        <option value="Brazil">Brazil</option>
                        <option value="Canada">Canada</option>
                        <option value="China">China</option>
                        <option value="France">France</option>
                        <option value="Germany">Germany</option>
                        <option value="India">India</option>
                        <option value="Italy">Italy</option>
                        <option value="Japan">Japan</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Netherlands">Netherlands</option>
                        <option value="Pakistan">Pakistan</option>
                        <option value="Singapore">Singapore</option>
                        <option value="South Korea">South Korea</option>
                        <option value="Sweden">Sweden</option>
                        <option value="Switzerland">Switzerland</option>
                        <option value="Turkey">Turkey</option>
                        <option value="UK">UK</option>
                        <option value="USA">USA</option>

                      </Form.Control>
                      <Form.Control.Feedback type="invalid">{errors.institutecountry}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Form.Label className='mb-0'>Select Your Specialization Field</Form.Label>
                    <Dropdown className="w-100">
                      <Dropdown.Toggle variant="secondary" className="w-100 ">
                        {formData.specialization || "Search Specialization"} {/* Display selected specialization or default text */}
                      </Dropdown.Toggle>
                      {/* <Dropdown.Menu style={{ maxHeight: '250px', overflowY: 'auto' }} className="w-100">
                        <Form.Control
                          type="text"
                          placeholder="Search..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="p-2"
                        />
                        {filteredSpecialists.length === 0 ? (
                          <Dropdown.Item as="button" disabled>No results found</Dropdown.Item>
                        ) : (
                          filteredSpecialists.slice(0, 10).map((specialist) => (
                            <Dropdown.Item
                              as="button"
                              onClick={() => handleSpecialtyChange(specialist)}
                              key={specialist.id}
                            >
                              {specialist.specialization_Name}xs
                            </Dropdown.Item>
                          ))
                        )}
                      </Dropdown.Menu> */}

                      <Dropdown.Menu style={{ maxHeight: '250px', overflowY: 'auto' }} className="w-100">
                        <Form.Control
                          type="text"
                          placeholder="Search..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="p-2"
                        />
                        {/* Dropdown items */}
                        {filteredSpecialists.length === 0 ? (
                          <Dropdown.Item as="button" disabled>No results found</Dropdown.Item>
                        ) : (
                          filteredSpecialists.map((specialist) => (
                            <Dropdown.Item
                              as="button"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSpecialtyChange(specialist);
                              }}
                              key={specialist.id}
                            >
                              {specialist.specialization_Name}
                            </Dropdown.Item>
                          ))
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                    {errors.specialization && (
                      <div className="text-danger mt-1">{errors.specialization}</div>
                    )}
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col md={6} className='mb-3'>
                    <Button className="w-100" variant="secondary" onClick={handlePrev} size="lg" block>
                      Previous
                    </Button>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Button className="w-100 btn_primary" variant="primary" onClick={handleNext} size="lg" block>
                      Next
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            {/* Step 4: Professional Info */}
            {step === 4 && (
              <div className="step mt-3">
                <h3 className="text-center m-4">Professional Info</h3>
                <Row>
                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formExperience">
                      <Form.Label className='mb-0'>Experience in years</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter Experience"
                        name="experience"
                        value={formData.experience}
                        onChange={handleChange}
                        isInvalid={errors.experience}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.experience}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Form.Group>
                      <div className='d-flex'>
                        <div className='w-50 me-2'>
                          <Form.Label className='mb-0'>Duty Start Time</Form.Label>
                          <Form.Control
                            type="time"
                            placeholder="Start Time"
                            name="dutyStartTime"
                            value={formData.dutyStartTime || ''}
                            onChange={handleChange}
                            isInvalid={errors.dutyStartTime}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.dutyStartTime}
                          </Form.Control.Feedback>
                        </div>
                        <div className='w-50'>
                          <Form.Label className='mb-0'>Duty End Time</Form.Label>
                          <Form.Control
                            type="time"
                            placeholder="End Time"
                            name="dutyEndTime"
                            value={formData.dutyEndTime || ''}
                            onChange={handleChange}
                            isInvalid={errors.dutyEndTime}
                            min={formData.dutyStartTime || undefined} // ⬅️ This enforces end > start in UI
                            required
                          />

                          <Form.Control.Feedback type="invalid">
                            {errors.dutyEndTime}
                          </Form.Control.Feedback>
                        </div>
                      </div>


                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  {/* <Col md={6} className='mb-3'>
                    <Form.Group controlId="formConsultationFee">
                      <Form.Label className='mb-0'>Consultation Fee</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Consultation Fee"
                        name="consultationFee"
                        value={formData.consultationFee}
                        onChange={handleChange}
                        isInvalid={errors.consultationFee}
                        required
                      />
                      <Form.Control.Feedback type="invalid">{errors.consultationFee}</Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}

                  <Col md={6} className='mb-3'>
                    <Form.Group controlId="formConsultationFee">
                      <Form.Label className='mb-0'>Consultation Fee</Form.Label>
                      <div className="d-flex">
                        {/* Numeric Input for Fee Value */}
                        <Form.Control
                          type="text"
                          maxLength="5"
                          pattern="\d{5}"
                          placeholder="12345"
                          name="consultationFee"
                          inputMode="numeric"
                          onInput={(e) => {
                            // Allow only numbers by removing any non-numeric characters
                            e.target.value = e.target.value.replace(/\D/g, '');
                          }}
                          value={formData.consultationFee} // Bind the numeric fee value here
                          onChange={handleChange}
                          isInvalid={errors.consultationFee}
                          required
                          style={{ width: '75%' }} // Adjust width as needed
                        />

                        {/* Dropdown for Fee Type or Currency */}
                        <Form.Control
                          as="select"
                          name="feeType"
                          value={formData.feeType || 'PKR'} // Default to PKR if not set
                          onChange={handleChange}
                          isInvalid={errors.feeType}
                          required
                          style={{ width: '25%', marginLeft: '10px' }} // Adjust width as needed
                        >
                          {/* <option value="">Select Currency</option> */}
                          <option value="PKR">PKR</option>
                          <option value="USD">USD</option>
                          {/* <option value="EUR">EUR</option>
                          <option value="INR">INR</option> */}
                        </Form.Control>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.consultationFee || errors.feeType}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>


                  <Col md={6} className='mb-3'>
                    <Form.Label className='mb-3 d-block'>Current Working</Form.Label>
                    {/* <Form.Control
                        type="text"
                        placeholder="Enter Current Working"
                        name="currentWorking"
                        value={formData.currentWorking}
                        onChange={handleChange}
                        isInvalid={errors.currentWorking}
                        required
                      /> */}
                    <Form.Check
                      inline
                      label="Yes"
                      name="currentWorking"
                      type="radio"
                      id="currentWorkingYes"
                      value="Yes"
                      checked={formData.currentWorking === 'Yes'}
                      onChange={handleChange}
                      isInvalid={errors.currentWorking}
                      required
                    />
                    <Form.Check
                      inline
                      label="No"
                      name="currentWorking"
                      type="radio"
                      id="currentWorkingNo"
                      value="No"
                      checked={formData.currentWorking === 'No'}
                      onChange={handleChange}
                      isInvalid={errors.currentWorking}
                      required
                    />
                    <Form.Control.Feedback type="invalid">{errors.currentWorking}</Form.Control.Feedback>

                  </Col>
                </Row>
                <Form.Group controlId="formResume">
                  <Form.Label className='mb-0'>Upload Resume</Form.Label>
                  <Form.Control
                    type="file"
                    name="resume"
                    onChange={handleFileChange}
                    isInvalid={errors.resume}
                    required
                  />
                  <Form.Control.Feedback type="invalid">{errors.resume}</Form.Control.Feedback>
                </Form.Group>
                <Row className="mt-4">
                  <Col md={6} className='mb-3'>
                    <Button className="w-100" variant="secondary" onClick={handlePrev} size="lg" block>
                      Previous
                    </Button>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Button className="w-100 btn_primary" variant="primary" onClick={handleNext} size="lg" block>
                      Next
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            {/* Step 5: Professional Info & Submit */}
            {step === 5 && (
              <div className="step mt-3">
                <h3 className="text-center m-4">Review your information</h3>
                {/* Display Summary of Data */}

                <div className="summary">
                  {/* <h4>Review your information:</h4> */}
                  <ul>
                    <li>Email: {formData.email}</li>
                    <li>Name: {formData.fullName}</li> {/* This will display "Dr." if it was added */}
                    <li>Password: {formData.password}</li>
                    <li>CNIC: {formData.cnic}</li>
                    <li>DOB: {formData.dob}</li>
                    <li>Gender: {formData.gender}</li>
                    <li>Network: {formData.network}</li>
                    <li>MobileNumber: {formData.contactNo}</li>
                    <li>Country: {formData.country}</li>
                    <li>City: {formData.city}</li>
                    {/* Instead of rendering the file object, show the file name */}
                    <li>Image: {formData.image ? formData.image.name : "No image uploaded"}</li>
                    <li>Address: {formData.currentAddress}</li>
                    <li>License No: {formData.licenseNo}</li>
                    <li>Institute Country: {formData.institutecountry}</li>
                    <li>Institute Name: {formData.institutename}</li>
                    <li>All Qualifications: {formData.allQualifications}</li>
                    <li>SpecialtyId: {formData.SpecialtyId}</li>
                    <li>Medical Degree: {formData.medicalDegree ? formData.medicalDegree.name : "No degree uploaded"}</li>
                    <li>Experience: {formData.experience + ' Years'}</li>
                    <li>Duty: {formData.doctorDutyTime}</li>
                    <li>Consultation Fee: {formData.consultationFee}{formData.feeType}</li>
                    <li>Current Working: {formData.currentWorking}</li>
                    <li>Resume: {formData.resume ? formData.resume.name : "No resume uploaded"}</li>
                  </ul>
                </div>

                <Row className="mt-4">
                  <Col md={6} className='mb-3'>
                    <Button className="w-100" variant="secondary" onClick={handlePrev} size="lg">
                      Previous
                    </Button>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Button
                      className="w-100"
                      variant="primary"
                      onClick={handleSubmit}
                      size="lg"
                      block
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Submitting...' : 'Submit'}
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};
export default Register;
